import { Box, Typography } from '@mui/material';
import { MAX_TOURNAMENT_ANNOUNCEMENT_LENGTH } from '@okletsplay/core';
import React, { FC, useMemo, useState } from 'react';
import { Controller, FormProvider, UseFormReturn } from 'react-hook-form';
import { TextInput } from 'shared/components/Form/TextInput';
import { CreateAnnouncementFormFields } from 'modules/notifications/interfaces/forms';

interface CreateFeedbackFormProps {
  form: UseFormReturn<CreateAnnouncementFormFields>;
}

export const CreateAnnouncementForm: FC<CreateFeedbackFormProps> = ({ form }) => {
  const control = form?.control;
  const [count, setCount] = useState(0);

  const isSubmitted = useMemo(
    () => Boolean(form?.formState?.isSubmitted),
    [form.formState.isSubmitted]
  );

  return (
    <FormProvider {...form}>
      <form>
        <Box display="flex" justifyContent="space-between" mb={0.5}>
          <Typography>Message</Typography>
          <Typography>{`${count}/${MAX_TOURNAMENT_ANNOUNCEMENT_LENGTH}`}</Typography>
        </Box>
        <Controller
          name="message"
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <>
              <TextInput
                multiline
                rows={6}
                value={value}
                onChange={(event) => {
                  onChange(event);
                  setCount(event.target.value.length);
                }}
                error={isSubmitted && Boolean(error)}
                placeholder="Write here an announcement details..."
              />
            </>
          )}
        />
      </form>
    </FormProvider>
  );
};
